// Ürün efektif (indirimli) fiyat hesabı — TEK DOĞRU KAYNAK.
// Saf fonksiyon: firebase/DOM import'u YOK → istemci, (ileride) sunucu ve test aynı çalışır.

export const MAX_DISCOUNT_PERCENT = 90;

/**
 * 2 ondalık, half-up (TL.kr). İleride functions/ tarafındaki kopya BİREBİR aynı olmalı
 * (iyzico satır toplamı = sepet toplamı şartı).
 */
export const round2 = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;

/** Timestamp(toMillis) | {seconds} (serileştirilmiş) | number | Date | ISO → epoch ms (çözülemezse null) */
const toMs = (t) => {
  if (t == null) return null;
  if (typeof t.toMillis === 'function') return t.toMillis();
  if (typeof t === 'number') return t;
  // Serileştirilmiş Firestore Timestamp (localStorage/JSON gidiş-dönüşü): { seconds, nanoseconds } / { _seconds }
  if (typeof t === 'object') {
    const secs = typeof t.seconds === 'number' ? t.seconds
      : (typeof t._seconds === 'number' ? t._seconds : null);
    if (secs != null) return secs * 1000;
  }
  const ms = new Date(t).getTime();
  return Number.isNaN(ms) ? null : ms;
};

/**
 * @param {Object} product - ürün dokümanı (price/poolPrice/fulfillmentType/discount)
 * @param {number} now - epoch ms (varsayılan Date.now())
 * @returns {{ base:number, price:number, isDiscounted:boolean, percent:number, endAt:number|null }}
 */
export const getEffectivePrice = (product, now = Date.now()) => {
  const base = Number(
    product?.fulfillmentType === 'pool'
      ? (product?.poolPrice ?? product?.price)
      : product?.price
  ) || 0;

  const d = product?.discount;
  const percent = d ? Number(d.percent) : 0;

  if (d && percent >= 1 && percent <= MAX_DISCOUNT_PERCENT) {
    const startMs = toMs(d.startAt);
    const endMs = toMs(d.endAt);
    const active = (startMs == null || now >= startMs) && (endMs != null && now <= endMs);
    if (active) {
      return { base, price: round2(base * (1 - percent / 100)), isDiscounted: true, percent, endAt: endMs };
    }
  }
  return { base, price: base, isDiscounted: false, percent: 0, endAt: null };
};

/** tr-TR para biçimi: "1.234,5 ₺". Geçersiz → "0 ₺". */
export const formatPrice = (value) => {
  const n = Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(safe) + ' ₺';
};
